import React from 'react';
import ReactDOM from 'react-dom/client';
import { StaffDeskThemeProvider } from './theme';
import App from './App';
import './assets/css/style.css';
import './assets/fonts/fonts.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <StaffDeskThemeProvider>
    <App />
  </StaffDeskThemeProvider>
);
